import { Injectable } from '@angular/core'

import manifestData from './manifest.json' // Use import instead of require

export interface Release {
  version: string
  changelog: string
}

@Injectable({
  providedIn: 'root',
})
export class ReleaseService {
  public releases: Release[] = this.sortReleasesByDate(manifestData)

  private sortReleasesByDate(releases: Release[]): Release[] {
    return releases.sort((a, b) => {
      // Parse version strings like '2024.12.07.05.58' into Date objects
      const dateA = this.parseVersionDate(a.version)
      const dateB = this.parseVersionDate(b.version)

      // Sort in descending order (newest first)
      return dateB.getTime() - dateA.getTime()
    })
  }

  private parseVersionDate(version: string): Date {
    // Split version like '2024.12.07.05.58' into components
    const parts = version.split('.')

    if (parts.length >= 5) {
      const year = parseInt(parts[0])
      const month = parseInt(parts[1]) - 1
      const day = parseInt(parts[2])
      const hour = parseInt(parts[3])
      const minute = parseInt(parts[4])

      return new Date(year, month, day, hour, minute)
    }

    // Fallback for invalid format - return epoch
    return new Date(0)
  }

  public getLatestVersion(): string {
    return this.releases[0].version
  }

  public getAllReleases(): Release[] {
    return this.releases
  }

  public getVersion(version: string): Release {
    return (
      this.releases.find((obj) => obj.version == version) || this.releases[0]
    )
  }
}
